module.exports = "/_next/static/images/offlineLight-8448b39c5dfa4ba95e6a6f1d6bf3109e.svg";